module.exports = "<div  *ngIf=\"loader\" class=\"loader loader_serach\">\r\n  <img src=\"../assets/ajax-loader.gif\">\r\n</div>"